<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">{{ operacion }}Prestación</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-3 mb-0 align-items-center">
            <div class="mb-3 mt-0 text-start ">
                <form (ngSubmit)="savePrestacion()" [formGroup]="morePrestacion">
                    <div class="mb-4 mt-2 text-start ">
                        <label for="especialidad" class="form-label">Especialidad</label>
                        <input
                            type="text"
                            class="form-control"
                            id="especialidad"
                            name="especialidad"
                            list="especialidades-datalist"
                            autocomplete="off"
                            placeholder="Escriba para buscar una especialidad"
                            [value]="especialidadTexto()"
                            (input)="onEspecialidadInput($any($event.target).value)"
                            (blur)="onEspecialidadBlur()"
                        />
                        <datalist id="especialidades-datalist">
                            @for (especialidad of especialidades; track especialidad.id) {
                                <option [value]="especialidad.x_descripcion"></option>
                            }
                        </datalist>
                        @if (morePrestacion.controls['especialidad'].invalid && (morePrestacion.controls['especialidad'].dirty || morePrestacion.controls['especialidad'].touched) && morePrestacion.controls['especialidad'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">La especialidad es requerida</small></div>
                        }
                    </div>
                    <div class="mb-4 mt-2 text-start ">
                        <label for="descripcion" class="form-label"><b>Descripción</b></label>
                        <input type="text" class="form-control" id="descripcion" formControlName="descripcion" placeholder="Ingrese una descripción">
                        @if (morePrestacion.controls['descripcion'].invalid && (morePrestacion.controls['descripcion'].dirty || morePrestacion.controls['descripcion'].touched) && morePrestacion.controls['descripcion'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">La descripción es requerida</small></div>
                        }
                    </div>
                    
                    @if (error()) {
                        <div class="alert alert-danger mt-4" role="alert">
                            <small>{{ error() }}</small>
                        </div>
                    }
                    <div class="d-grid mt-5 mb-2">
                        <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Prestación'}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>